import TenantConsentsPage from './tenant-consents-page';

function TenantConsentsFoundersPage() {
  return (
    <TenantConsentsPage
      filterType='Founder'
      pageTitle='Founder Commitments'
      pageDescription='Here you can create and modify commitments for founders.'
    />
  );
}

export default TenantConsentsFoundersPage;
